import { render, staticRenderFns } from "./DocumentRule.vue?vue&type=template&id=a970b8ea&scoped=true"
import script from "./DocumentRule.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentRule.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DocumentRule.vue?vue&type=style&index=0&id=a970b8ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a970b8ea",
  null
  
)

export default component.exports